export default {
  // ! search codebase for this cookie name
  // gravity forms events are in a different
  // scope, so some cookies have to be set in
  // the templates

  _set(cookieName = 'drElseySubscriberV1', value = 'true', days = 1) {
    const date = new Date();
    const expires = date.toUTCString(date.setTime(date.getTime() + (days*24*60*60*1000)));
    document.cookie = cookieName + '=' + value + ';expires=' + expires + '; path=/';
  },

  setNoInterest(cookieName = 'drElseySubscriberV1') {
    this._set(cookieName, 'noInterest', 7);
  },

  setSubscribed() {
    this._set('drElseySubscriberV1', 'subscribed', 90);
  },

  setViewedPromoLink() {
    this._set('drElseyPromoV1', 'viewedPromoLink', 7);
  },

  exists(cookieName) {
    return (document.cookie.indexOf(cookieName) != -1);
  },

  destroy(cookieName) {
    this._set(cookieName, 'false', -1);
  },
}
